import {
  EyeInvisibleOutlined,
  LogoutOutlined,
  SwapOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import React from 'react';
import { toneColors } from 'theme/tokens';
import { IssueSummary, IssueTabKey } from '../types';
import { ISSUE_TABS, formatCount } from '../utils';
import styles from '../style.module.scss';

const ICONS: Record<IssueTabKey, React.ReactNode> = {
  'roi-di': <LogoutOutlined />,
  'vang-mat': <EyeInvisibleOutlined />,
  'doi-id': <SwapOutlined />,
  'chua-co-tai-khoan': <UserAddOutlined />,
};

interface Props {
  /** `null` = chưa có số (đang tải hoặc tải lỗi): ô hiện "—", không hiện 0. */
  summary: IssueSummary | null;
  active: IssueTabKey;
  onOpen: (key: IssueTabKey) => void;
}

/**
 * Bốn ô số tóm tắt phía trên dải tab. Mỗi ô là một nút: bấm để mở tab tương ứng. Ô đang mở
 * khác các ô còn lại ở cả viền và dòng chữ "Đang xem" (không chỉ bằng màu).
 */
const SummaryTiles = ({ summary, active, onOpen }: Props) => (
  <ul className={styles.tiles} aria-label="Số Creator theo từng nhóm vấn đề">
    {ISSUE_TABS.map((tab) => {
      const tone = toneColors[tab.tone];
      const isActive = tab.key === active;
      const value = summary ? formatCount(summary[tab.countKey]) : '—';
      return (
        <li key={tab.key}>
          <button
            type="button"
            className={isActive ? `${styles.tile} ${styles.tileActive}` : styles.tile}
            aria-pressed={isActive}
            onClick={() => onOpen(tab.key)}
          >
            <span className={styles.tileHead}>
              <span
                className={styles.tileIcon}
                style={{ background: tone.soft, color: tone.ink }}
                aria-hidden
              >
                {ICONS[tab.key]}
              </span>
              <span className={styles.tileLabel}>{tab.label}</span>
            </span>
            <span className={styles.tileValue}>{value}</span>
            <span className={styles.tileHint}>{tab.hint}</span>
            <span className={styles.tileAction}>{isActive ? 'Đang xem' : 'Xem danh sách'}</span>
          </button>
        </li>
      );
    })}
  </ul>
);

export default SummaryTiles;
